import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';

interface IProps {
  enabled?: boolean;
}

const useList = ({ enabled = true }: IProps = {}) => {
  const query = useQuery({
    queryKey: ['teams', 'list'],
    queryFn: async () => {
      const response = await Api.list();
      return response.data.data;
    },
    enabled,
  });

  return {
    teams: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useList;
